import axios from 'axios';

async function requestRaw({
 url, data, method, headers, responseType,
}) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
 method, url, data, headers, responseType: responseType || 'json',
});
      if (res.data && !res.data.error) {
        return resolve(res.data);
      }
      return reject(res.data.error);
    } catch (e) {
      return reject(e.data);
    }
  });
}

async function requestRawWithParams({
                            url, data, method, headers, responseType, params,
                          }) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        method, url, data, headers, params, responseType: responseType || 'json',
      });
      if (res.data && !res.data.error) {
        return resolve(res.data);
      }
      return reject(res.data.error);
    } catch (e) {
      return reject(e.data);
    }
  });
}

// eslint-disable-next-line consistent-return
async function request({
 url, data, method, headers,
 responseType,
}, { commit }) {
  return new Promise(async (resolve, reject) => {
    commit('error', null);
    try {
      const success = await requestRaw({
 method, url, data, headers, responseType,
});

      return resolve(success);
    } catch (e) {
      let error;
      if (e) {
        if (e.message && Array.isArray(e.message)) {
          error = e.message[0].messages[0].message;
        } else {
          error = e.message || e.error || e;
        }
      }
      commit('error', error);
      return reject(error);
    }
  });
}

// eslint-disable-next-line consistent-return
async function requestWithParams({
                         url, data, method, headers,
                         responseType, params,
                       }, { commit }) {
  return new Promise(async (resolve, reject) => {
    commit('error', null);
    try {
      const success = await requestRawWithParams({
        method, url, data, headers, responseType, params,
      });

      return resolve(success);
    } catch (e) {
      let error;
      if (e) {
        if (e.message && Array.isArray(e.message)) {
          error = e.message[0].messages[0].message;
        } else {
          error = e.message || e.error || e;
        }
      }
      commit('error', error);
      return reject(error);
    }
  });
}

async function get(url, { commit, headers, responseType }) {
  return request({
    method: 'get', url, headers, responseType,
  }, { commit });
}

async function post(url, data, { commit }, headers, responseType) {
  return request({
 method: 'post', url, data, headers, responseType,
}, { commit });
}

async function postWithParams(url, data, params, { commit }) {
  return requestWithParams({
 method: 'post', url, data, params,
}, { commit });
}

async function put(url, data, { commit }) {
  if (data) {
    return request({ method: 'put', url, data }, { commit });
  }
  return request({ method: 'put', url }, { commit });
}

async function patch(url, data, { commit }) {
  if (data) {
    return request({ method: 'patch', url, data }, { commit });
  }
  return request({ method: 'patch', url }, { commit });
}

async function del(url, { commit }) {
  return request({ method: 'delete', url }, { commit });
}

export {
  requestRaw,
  request,
  get,
  post,
  put,
  patch,
  del,
  postWithParams,
};
